import { find, startCase } from 'lodash';
import API from '../api';

// one cached promise per order type so duplicate calls are not made ('' = full list)
const cache = new Map();

/**
 * List of supported Ad Providers, fetched from the API and cached per orderType.
 * @param options object of options to build the list
 * @param options.orderType optional order type to filter the returned providers server-side
 * @param options.includeEmpty boolean to include an empty label/value pair at the beginning
 * @param options.emptyData object of data to spread into the empty label/value pair if includeEmpty is true
 */
export async function list(options = {}) {
  const orderType = options.orderType || '';

  if (!cache.has(orderType)) {
    cache.set(orderType, API.AdProvider.list(orderType ? { orderType } : {})
      .then(providers => providers.map(provider => ({
        label: provider.name,
        value: provider.key,
      })))
      .catch(error => {
        cache.delete(orderType);
        throw error;
      }));
  }

  const providers = await cache.get(orderType);

  if (options.includeEmpty === true) {
    const emptyData = options.emptyData ?? {};

    return [
      { label: '', value: '', ...emptyData },
      ...providers,
    ];
  }

  return [...providers];
}

/**
 * Resolve a display name from an already-fetched provider list. Keys the API no
 * longer returns (e.g. deprecated triton) fall back to a readable label instead
 * of throwing.
 */
export function getName(providerKey, providers = []) {
  return find(providers, { value: providerKey })?.label
    || (providerKey ? startCase(providerKey) : 'Unknown');
}

export default {
  list,
  getName,
};
